import { Autocomplete, Box, CircularProgress, TextField, Typography } from '@mui/material';
import { CancelToken } from 'apisauce';
import React, { useCallback } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import appapi from '../api/apiClient';
import { debounce } from 'lodash';
import { getIn, useFormikContext } from 'formik';

export default function PortDropDown({ lable, selectedId, name, onSelect }) {
  const [loading, setLoading] = useState(true);
  const [ports, setPorts] = useState([]);
  const [filter, setFilter] = useState(null);
  const { setFieldValue, values } = useFormikContext();

  let source = CancelToken.source();

  const getPorts = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(`common/ports`, {
      pageNumber: 1,
      pageSize: 30,
      filter,
    });
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setPorts(data.response || []);
      } else {
        setPorts([]);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    getPorts();
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [filter]);

  const request = debounce((tempValue) => {
    setFilter(tempValue ? tempValue : null);
  }, 400);

  const debouceRequest = useCallback((value) => request(value), []);

  const filteredPorts = ports.filter((res) => res._id !== selectedId);

  return (
    <Autocomplete
      // onSelect={(event, newValue) => onSelect(newValue)}
      id="asynchronous-demo"
      getOptionLabel={(option) => option.portName}
      onInputChange={(e) => {
        if(e && e?.target) {
          debouceRequest(e.target.value ? e.target.value.trimStart() : null);
        } else {
          debouceRequest( null);
        }
      }}
      value={getIn(values, name)}
      onChange={(event, newValue) => {
        if (newValue) {
          setFieldValue(name, newValue);
          if (onSelect) {
            onSelect(newValue);
          }
        } else {
          setFieldValue(name, null);
        }
      }}
      options={filteredPorts}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={lable}
          // InputProps={{
          //   ...params.InputProps,
          //   endAdornment: (
          //     <React.Fragment>
          //       {loading ? <CircularProgress color="inherit" size={20} /> : null}
          //       {params.InputProps.endAdornment}
          //     </React.Fragment>
          //   ),
          // }}
        />
      )}
      renderOption={(props, option) => (
        <Box
          component="li"
          className="flex flex-col"
          {...props}
        >
          <Typography className="fw-regular ff-Roboto fs-12">
            {' '}
            {option.portName} ({option.locationCode}){' '}
          </Typography>
          {/* <br></br>
          <Typography className='fw-regular ff-Roboto fs-12'> {option.country
          } </Typography> */}
        </Box>
      )}
    />
  );
}
